<template>
    <div>
        <div class="modal fade" id="modalAlertBanner" tabindex="-1" aria-labelledby="modalAlertBannerLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-dark" id="modalAlertBannerLabel">Banner Alert</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div style="justify-content: center; align-items: flex-end">
                            <div class="alert alert-warning" role="alert" v-for="(bannerAlert, index) in bannerAlerts" :key="index">
                                <strong>Warning!</strong> {{ bannerAlert.text}}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="dismiss" v-if="dismissible">
                            Dismiss
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import bannerType from "@/data/bannerType.js"

export default {
    name: 'ModalAlertBanner',
    props: {
        bannerAlerts: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        getBanner() {
            return this.searchStore.getBanner;
        },
        getBannerType() {
            return bannerType;
        },
        dismissible() {
            if (this.getBanner.type == this.getBannerType.DISMISSIBLE) {
                return true;
            }
            return false
        }
    },
    methods: {
        dismiss() {
            const modalElement = document.getElementById('modalAlertBanner');
            if (modalElement) {
                const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
                modal.hide();
            }

            this.$emit('dismiss');
        }
    },
}
</script>
